import { BaseModel } from '~/models/baseModel';


export class BalesByWoolTypeModel extends BaseModel {
    public bales:number;
    public woolType:string;
}
